module.exports = __webpack_public_path__ + "static/media/search-btn.02748c15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/search-btn.svg
// module id = 218
// module chunks = 0